import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { useCallback } from 'react';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';
import { useAppNavigate } from 'utils/url/useAppNavigate';

import { exitReasonLabel } from '../exitReasonLabel';

type RoutedThroughAiAgentProps = {
  readonly node: ConversationAutomationAuditLogEntry<'AUTOMATION_CHATBOT_NODE_VISITED'>;
};

export function RoutedThroughAiAgent({
  node,
}: RoutedThroughAiAgentProps): JSX.Element {
  const navigate = useAppNavigate();
  const hasAiAgentReadAccess = useHasAccess([
    'settings.integration.channel.edit',
    'settings.chatbot',
  ]);

  const handleGoToAiAgent = useCallback(() => {
    if (!node.chatbot_id) return;
    navigate({
      path: '/settings/ai-agents/mim/:id',
      params: {
        path: {
          id: node.chatbot_id,
        },
      },
    });
  }, [navigate, node.chatbot_id]);

  const paragraphStyle = node.skipped_due_to_quota
    ? { textDecoration: 'line-through' }
    : {};

  return (
    <FlexBox alignItems="center" gap="200">
      <Text.Paragraph>
        {node.skipped_due_to_quota && <span>(Skipped due to quota) </span>}

        <span style={paragraphStyle}>
          AI agent
          {node.chatbot_name && (
            <>
              : <strong>{node.chatbot_name}</strong>
            </>
          )}{' '}
          {node.exit_reason && exitReasonLabel[node.exit_reason] && (
            <>
              · <strong>{exitReasonLabel[node.exit_reason]}</strong>
            </>
          )}
        </span>
      </Text.Paragraph>
      {hasAiAgentReadAccess && node.chatbot_id && (
        <Button variant="secondary" onClick={handleGoToAiAgent}>
          Go to AI agent
        </Button>
      )}
    </FlexBox>
  );
}
